import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { addUserValues } from "../../utils/formik/initialValues";
import { addUserSchema } from "../../utils/formik/validationSchema";
import { userManagementData } from "../../utils/tableData";
import DeleteConfirmContent from "../../components/modal-contents/DeleteConfirmModalContent";
import SubAdminApi from "../../services/subAdminService";
const CustomTable = Loadable(
  React.lazy(() => import("../../components/custom-table/CustomTable"))
);
const CustomModel = Loadable(
  React.lazy(() => import("../../components/custom-model/CustomModel"))
);
import Loadable from "../../components/Loadable";
import { notify } from "../../bmr/utils/methods/notification";
import EditorApi from "../../services/editorManagementService";
import HospitalApi from "../../services/hospitalService";
import ListDrawer from "../../components/ListDrawer/ListDrawer";
import SearchableDropdown from "../../components/SearchableDropdown/SearchableDropdown";
import CustomDrawer from "../../components/custom-drawer/CustomDrawer";
import HeaderBackNav from "../../components/header-back-navigation/HeaderBackNav";
import CustomSearchbar from "../../components/custom-searchbar/CustomSearchbar";
import SkeletonLoader from "../../utilites/SkeltonLoader";
import NoDataCard from "../../components/no-data-card";
import { DoctorIcon } from "../../assets/products-svg/ProductSvg"; // Make sure to import DoctorIcon
import { Typography } from "@mui/material";

const convertUserData = (data) => {
  return data.map((userMangement) => {
    let transformedName = userMangement?.name;
    let transformeEmail = userMangement?.email;
    let transformedType = userMangement?.role;
    
    // Handle PI data properly - check both pi_ids and investigator_details
    let piData = userMangement?.pi_ids;
    let investigatorData = userMangement?.investigator_details;
    let transformedPi = "N/A";
    let piListData = [];
    
    // First check if there are multiple PIs in pi_ids
    if (piData && typeof piData === 'object' && Object.keys(piData).length > 0) {
      // Convert the object to array of PI objects
      piListData = Object.values(piData);
      transformedPi = piListData.length;
    } 
    // Then check if there's a single investigator
    else if (investigatorData && typeof investigatorData === 'object' && Object.keys(investigatorData).length > 0) {
      // investigator_details is a single object, not an object with keys
      piListData = [investigatorData];
      transformedPi = 1;
    }
    
    // Ensure each PI item has proper primitive values
    piListData = piListData.map(pi => ({
      id: pi.id,
      name: String(pi.name || ''),
      email: pi.email || '',
    }));
    
    let transformedAssigned = userMangement?.phaseCount;
    let phaseList = userMangement?.phaseDetails;
    let transformRowId = userMangement?.id;
    
    return {
      // Display data - these will be shown in the table
      displayData: [
        transformedName,                    // 0: Name (string)
        transformeEmail,                   // 1: Email (string) 
        transformedType,                   // 2: Type (string)
        transformedPi,                     // 3: PI Count (number/string)
        transformedAssigned,               // 4: Assigned Count (number/string)
        transformRowId,                    // 5: Row ID
      ],
      // Internal data - for drawers and click handlers
      internalData: {
        piListData,                        // PI Data for drawer
        phaseList,                         // Phase Data for drawer
        rowId: transformRowId,             // Row ID
        originalData: userMangement        // Store original data for edit
      }
    };
  });
};

export const UserManagement = () => {
  const [openAddModal, setOpenAddModal] = React.useState(false);
  const [openEditModal, setOpenEditModal] = React.useState(false);
  const [openDeleteConfirmModal, setOpenDeleteConfirmModal] = React.useState(false);
  const [tableFilters, setTablesFilters] = useState({ searchData: "" });
  const [userMangement, setUserMangement] = useState(userManagementData);
  const [initialValues, setInitialValues] = useState(addUserValues);
  const [userManagementResponse, setUserManagementResponse] = useState([]);
  const [currentPage, setCurrentpage] = useState(1);
  const [rowId, setRowId] = useState(null);
  const [roleID, setRoleID] = useState("");
  const [newRoleIDs, setNewRoleIDs] = useState([]);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [roleList, setRoleList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalPage, setTotalPage] = useState(1);
  const [deleteRowData, setDeleteRowData] = useState(null);
  const [roleDropDownId, setRoleDropDownId] = useState('');
  const [roleDropDownSlug, setroleDropDownSlug] = useState('');
  
  const [openDrawer, setOpenDrawer] = useState(false);
  const [phaseListData, setPhaseListData] = useState([]);
  const [openPiDrawer, setOpenPiDrawer] = useState(false);
  const [piListData, setPiListData] = useState([]);
  const [allHospitals, setAllHospitals] = useState([]);
  const [allPIs, setAllPIs] = useState([]);
  const [phaseList, setPhaseList] = useState([]);
  
  // New state for PI drawer search
  const [piSearch, setPiSearch] = useState("");

  const [modelData, setModelData] = useState({
    title: "Add User",
    editTitle: "Edit User",
    children: [
      {
        type: "dropdown",
        name: "userType",
        label: "User Type",
        placeholder: "Enter Type",
        data: roleList,
        IsRequired: true,
      },
      {
        type: "input",
        name: "name",
        label: "Name",
        placeholder: "Enter Name",
        IsRequired: true,
      },
      {
        type: "input",
        name: "email",
        label: "Email",
        placeholder: "Enter Email",
        IsRequired: true,
      },
      {
        type: "number",
        name: "phoneNumber",
        label: "Phone Number",
        placeholder: "Enter Phone Number",
        IsRequired: true,
      },
    ],
  });

useEffect(() => {
  if (openAddModal || openEditModal) {
    // For role ID 5, always load all PIs
    if (roleDropDownId == 5) {
      getPersonalInvestigatorList();
    }
    // For project manager, only load PIs if hospitals are already selected (edit mode)
    else if (roleDropDownSlug === 'project-manager' && initialValues?.hospital?.length > 0) {
      const hospitalIds = initialValues.hospital.map(h => h.id);
      EditorApi.getPIByHospitalIds({
        hospital_ids: hospitalIds
      })
        .then((res) => {
          const piOptions = res?.data?.map((pi) => ({
            id: pi.id,
            name: pi.name,
            label: pi.name
          }));
          setAllPIs(piOptions);
        })
        .catch((error) => {
          notify.error(error);
          setAllPIs([]);
        });
    }
  }
}, [openAddModal, openEditModal, roleDropDownId, roleDropDownSlug, initialValues?.hospital]);

 useEffect(() => {
  const newChildren = [
    {
      type: "input",
      name: "name",
      label: "Name",
      placeholder: "Enter Name",
      IsRequired: true,
    },
    {
      type: "number",
      name: "phoneNumber",
      label: "Phone Number",
      placeholder: "Enter Phone Number",
      IsRequired: true,
    },
  ];
  
  if (rowId == "") {
    newChildren.push({
      type: "input",
      name: "email",
      label: "Email",
      placeholder: "Enter Email",
      IsRequired: true,
    });
    newChildren.unshift({
      type: "dropdown",
      name: "userType",
      label: "User Type",
      placeholder: "Enter Type",
      data: roleList,
      IsRequired: true,
    });
  } else {
    newChildren.push({
      type: "input",
      name: "email",
      label: "Email",
      placeholder: "Enter Email",
      IsRequired: true,
      disabled: true,
    });
    newChildren.unshift({
      type: "dropdown",
      name: "userType",
      label: "User Type",
      placeholder: "Enter Type",
      data: roleList,
      IsRequired: true,
      disabled: true,
    });
  }

  // FIX: Show PI and Phase fields for both role ID 5 AND Editor role
  const shouldShowPiAndPhase = roleDropDownId == 5 || roleDropDownSlug === 'editor';
  
  if (shouldShowPiAndPhase) {
    // For role ID 5, show PI dropdown with current allPIs state
    newChildren.push({
      type: "component",
      name: "principalInvestigator",
      label: "Principal Investigator",
      placeholder: "Select Principal Investigator",
      IsRequired: true,
      component: SearchableDropdown,
      props: {
      options: Array.isArray(allPIs) ? allPIs : [],
      multiple: false,
      placeholder: "Search principal investigators...",
      label: "Principal Investigator",
      required: true,
     filterOptions: (options, state) => {
        if (!state.inputValue.trim()) return options;
        
        const searchLower = state.inputValue.toLowerCase().trim();
        return options.filter(option => {
          const name = option?.name || option?.label || "";
          const email = option?.email || "";
          
          // Exact matching - you can adjust the logic as needed
          return (
            name.toLowerCase().includes(searchLower) ||
            email.toLowerCase().includes(searchLower)
          );
        });
      }
      // FIX: Add search functionality
    }
    },
    {
      type: "multidropdown",
      name: "trial",
      label: "Phase",
      placeholder: "Select Phase",
      data: phaseList,
      IsRequired: true,
    });
  } 
  else if (roleDropDownSlug == 'project-manager') {
    // For project manager, show hospitals first, then PIs
    newChildren.push({
      type: "component",
      name: "hospital",
      label: "Hospital",
      IsRequired: true,
      component: SearchableDropdown,
      props: {
        options: Array.isArray(allHospitals) ? allHospitals : [],
        multiple: true,
        placeholder: "Search hospitals...",
        label: "Hospital",
        required: true
      }
    });

    // FIX: For project manager, initially show empty PI options until hospitals are selected
    const shouldShowPIs = roleDropDownSlug === 'project-manager' && 
                         initialValues?.hospital?.length > 0;
    
    newChildren.push({
      type: "component",
      name: "principalInvestigator",
      label: "Principal Investigator",
      placeholder: shouldShowPIs ? "Search principal investigators..." : "Please select hospitals first",
      IsRequired: true,
      component: SearchableDropdown,
      props: {
        options: shouldShowPIs ? (Array.isArray(allPIs) ? allPIs : []) : [],
        multiple: true,
        placeholder: shouldShowPIs ? "Search principal investigators..." : "Please select hospitals first",
        label: "Principal Investigator",
        required: true,
        disabled: !shouldShowPIs // Disable if no hospitals selected
      }
    });
  }
  else if (roleDropDownId == 2) {
    newChildren.push({
      type: "component",
      name: "hospital",
      label: "Hospital",
      placeholder: "Select Hospital",
      IsRequired: true,
      component: SearchableDropdown,
      props: {
        options: Array.isArray(allHospitals) ? allHospitals : [],
        multiple: true,
        placeholder: "Search hospitals...",
        label: "Hospital",
        required: true
      }
    });
  }

  setModelData((prevModelData) => ({
    ...prevModelData,
    children: newChildren,
  }));
}, [roleDropDownId, rowId, roleDropDownSlug, roleList, allHospitals, allPIs, phaseList, initialValues?.hospital]);
  const navigate = useNavigate();

  const getPersonalInvestigatorList = () =>
    EditorApi.subadminDropDown()
      .then((res) => {
        const piData = res.data.map(pi => ({
          ...pi,
          label: pi.name
        }));
        setAllPIs(piData);
      })
      .catch((error) => {
        notify.error(error)
      });

  const getPhase = (piId) => {
    EditorApi.getPhaseDropDown('', piId)
      .then((res) => {
        const data = res?.data?.map((val) => ({
          id: val.id,
          name: `${val.title}(${val.product_details?.name})`,
        }));
        setPhaseList(data || []);
        setModelData((prevState) => ({
          ...prevState,
          children: prevState.children.map((child) =>
            child.name === "trial" ? { ...child, data: data || [] } : child
          ),
        }));
      })
      .catch((error) => {
        notify.error(error);
        setPhaseList([]);
      });
  };

  const getHospitalList = () => {
    return HospitalApi.getHospitalData('', 1, '')
      .then((res) => {
        const rowData = res?.data?.map((list) => {
          return {
            id: list?.id,
            name: list?.name + ' ' + `(${list?.city_name})`,
            label: list?.name + ' ' + `(${list?.city_name})`
          };
        });
        setAllHospitals(rowData);
      })
      .catch((error) => {
        notify.error(error)
      });
  };

  const handleNavigateToDetails = React.useCallback((rowData) => {
    const rowId = rowData?.[rowData?.length - 1] || "";
    navigate(`onboard-users-details/${rowId}`, {
      state: [
        { name: "Onboard Users", path: location.pathname },
        {
          name: "Details",
          path: `${location.pathname}/onboard-users-details/${rowId}`,
        },
      ],
    });
  }, [navigate]);

  useEffect(() => {
    getSubAdminListByRoles();
    getPersonalInvestigatorList();
    getHospitalList();
  }, []);

  useEffect(() => {
    if (
      (tableFilters?.searchData &&
        tableFilters?.searchData[tableFilters?.searchData?.length - 1] != " ") ||
      newRoleIDs?.length > 0
    ) {
      setLoading(true);
      getSubAdminList();
    }
  }, [currentPage, tableFilters, roleID, newRoleIDs]);

  const getSubAdminListByRoles = () =>
    SubAdminApi.getSubAdminListByRoles().then((res) => {
      const dataList = res?.data?.map((list) => ({
        id: list?.id,
        name: list?.title,
        slug: list?.slug,
      }));
      setNewRoleIDs(dataList?.map((val) => val.id));
      setRoleList(dataList);
    });

  const getSubAdminList = () => {
    SubAdminApi.getSubAdminData(
      10,
      currentPage,
      tableFilters?.searchData,
      roleID
    )
      .then((res) => {
        let convertedData = convertUserData(res?.data || []);
        
        let rowData = convertedData.map(item => item.displayData);
        
        setUserManagementResponse(convertedData);
        
        setUserMangement((prev) => ({
          ...prev,
          rows: [...rowData],
        }));

        setTotalPage(
          Math.ceil(res?.page_details?.no_of_records / res?.page_details?.limit)
        );
        setCurrentpage(res?.page_details?.page);
        setLoading(false);
      })
      .catch((error) => {
        notify.error(error)
        setLoading(false);
      });
  };

const handleOpenAddModal = () => {
  const baseValues = {
    ...addUserValues,
    hospital: [],
    principalInvestigator: roleDropDownId == 5 ? null : [],
    trial: [],
    slug: roleDropDownSlug || '', // Ensure it's always set, even if empty
    userType: ''
  };

  setInitialValues(baseValues);
  setRowId("");
  setOpenAddModal(true);
  setRoleDropDownId('');
  setroleDropDownSlug('');
  setAllPIs([]);
};

 const handleOpenEditPrincipalModal = async (row, rowIndex) => {
  if (userManagementResponse && userManagementResponse[rowIndex]) {
    const internalData = userManagementResponse[rowIndex]?.internalData;
    const rowId = internalData?.rowId;
    
    setRowId(rowId);
    const originalData = internalData?.originalData;

    await Promise.all([
      getHospitalList(),
      getPersonalInvestigatorList()
    ]);

    const hospitalIds = originalData?.phase_all_hospital?.length > 0
      ? originalData.phase_all_hospital.map(hospital => hospital.id)
      : originalData?.hospital_id
        ? [originalData.hospital_id]
        : [];
    
    const hospitalObjects = allHospitals.filter(hospital => 
      hospitalIds.includes(hospital.id)
    );

    // FILTER PIs BASED ON SELECTED HOSPITALS
    let filteredPIs = allPIs;
    if (hospitalIds.length > 0 && originalData?.role_details?.slug === "project-manager") {
      try {
        const res = await EditorApi.getPIByHospitalIds({
          hospital_ids: hospitalIds
        });
        filteredPIs = res?.data?.map((pi) => ({
          id: pi.id,
          name: pi.name,
          label: pi.name
        })) || [];
      } catch (error) {
        notify.error(error);
        // Fallback to all PIs if API call fails
        filteredPIs = allPIs;
      }
    }

    const principalInvestigatorIds = originalData?.pi_ids && Object.keys(originalData.pi_ids).length > 0
      ? Object.values(originalData.pi_ids).map(pi => pi.id)
      : originalData?.investigator_details?.id
        ? [originalData.investigator_details.id]
        : [];
    
    const piObjects = filteredPIs.filter(pi => 
      principalInvestigatorIds.includes(pi.id)
    );

    const editValues = {
      userType: originalData?.role_id,
      name: originalData?.name,
      email: originalData?.email,
      phoneNumber: originalData?.phone,
      selectTrial: originalData?.phase_id,
      hospital: hospitalObjects,
      principalInvestigator: originalData?.role_id == 5 ? (piObjects[0] || null) : piObjects,
      trial: originalData?.phaseDetails?.map(item => item.id) || [],
      slug: originalData?.role_details?.slug
    };

    setInitialValues(editValues);
    
    setOpenEditModal(true);
    setRoleDropDownId(originalData?.role_id);
    setroleDropDownSlug(originalData?.role_details?.slug);
    
    // Also update the allPIs state with filtered PIs for the dropdown
    setAllPIs(filteredPIs);
    
    if (originalData?.investigator_details?.id) {
      getPhase(originalData?.investigator_details?.id);
    }
  }
};

 const handleAddModelValues = async (values) => {
  setSubmitLoading(true);
  
  const hospitalIds = Array.isArray(values?.hospital) 
    ? values.hospital.filter(h => h && h.id).map(h => h.id) 
    : values?.hospital?.id 
      ? [values.hospital.id] 
      : [];

  const piIds = Array.isArray(values?.principalInvestigator) 
    ? values.principalInvestigator.filter(pi => pi && pi.id).map(pi => pi.id)
    : values?.principalInvestigator?.id 
      ? [values.principalInvestigator.id] 
      : [];

  const phaseIds = Array.isArray(values?.trial) 
    ? values.trial
    : [];

  const submitData = {
    name: values?.name || '',
    email: values?.email || '',
    country_code: "91",
    phone: values?.phoneNumber?.toString() || '',
    role_id: values?.userType || '',
  };

  // FIX: Only add hospital_id if we have valid hospital IDs
  if (roleDropDownId == 5) {
    if (phaseIds.length > 0) submitData.phase_ids = phaseIds;
    if (piIds.length > 0) submitData.investigator_id = piIds[0];
  }
  
  if (roleDropDownId == 2 && hospitalIds.length > 0) {
    submitData.hospital_id = hospitalIds;
  }
  
  if (roleDropDownSlug === "project-manager") {
    // FIX: Only add hospital_id if hospitals are selected
    if (hospitalIds.length > 0) {
      submitData.hospital_id = hospitalIds;
    }
    // FIX: Only add investigator_id if PIs are selected
    if (piIds.length > 0) {
      submitData.investigator_id = piIds;
    }
  }

  SubAdminApi.addSubAdmin(submitData)
    .then((res) => {
      if (res?.status === 200) {
        getSubAdminList();
        notify.success(res?.message)
        setOpenAddModal(false);
        setSubmitLoading(false);
      }
    })
    .catch((error) => {
      notify.error(error)
      setSubmitLoading(false);
    });
};

  const handleEditModelValues = (values) => {
    const subAdminEditData = userManagementResponse.find((userMangement) => {
      return userMangement.internalData.rowId == rowId;
    });
    
    const hospitalIds = Array.isArray(values?.hospital) 
      ? values.hospital.filter(h => h && h.id).map(h => h.id)
      : values?.hospital?.id 
        ? [values.hospital.id] 
        : [];

    const piIds = Array.isArray(values?.principalInvestigator) 
      ? values.principalInvestigator.filter(pi => pi && pi.id).map(pi => pi.id)
      : values?.principalInvestigator?.id 
        ? [values.principalInvestigator.id] 
        : [];

    const phaseIds = Array.isArray(values?.trial) 
      ? values.trial
      : [];

    const dataIds = subAdminEditData?.internalData?.originalData?.phaseDetails?.map(item => item.id) || [];
    const missingIds = dataIds?.filter(id => !phaseIds.includes(id));
    
    const originalInvestigatorId = subAdminEditData?.internalData?.originalData?.investigator_details?.id;
    const isInvestigator = originalInvestigatorId && originalInvestigatorId !== (piIds[0] || null) 
      ? originalInvestigatorId 
      : 0;

    const submitData = {
      name: values?.name || '',
      email: values?.email || '',
      country_code: "91",
      phone: values?.phoneNumber?.toString() || '',
      role_id: values?.userType || '',
    };

    if (roleDropDownId == 5) {
      if (phaseIds.length > 0) submitData.phase_ids = phaseIds;
      if (piIds.length > 0) submitData.investigator_id = piIds[0];
      if (missingIds.length > 0) submitData.removedPhaseIds = missingIds;
      if (isInvestigator) submitData.removedInvestigatorId = isInvestigator;
    }
    
    if (roleDropDownId == 2 && hospitalIds.length > 0) {
      submitData.hospital_id = hospitalIds;
    }
    
      if (roleDropDownSlug === "project-manager") {
    // FIX: Only add hospital_id if hospitals are selected
    if (hospitalIds.length > 0) {
      submitData.hospital_id = hospitalIds;
    }
    // FIX: Only add investigator_id if PIs are selected  
    if (piIds.length > 0) {
      submitData.investigator_id = piIds;
    }
  }

    setSubmitLoading(true);
    SubAdminApi.editSubAdmin(submitData, rowId)
      .then((res) => {
        if (res.status === 200) {
          getSubAdminList();
          notify.success(res?.message)
          setOpenEditModal(false);
          setSubmitLoading(false);
        }
      })
      .catch((error) => {
        notify.error(error)
        setSubmitLoading(false);
      });
  };

  const handleOpenDeleteConfirmModal = (row) => {
    setOpenDeleteConfirmModal(true);
    setDeleteRowData(row);
  };

  const handlePagination = (value) => {
    setCurrentpage(value);
  };

  const handleTableFilters = (e) => {
    setTablesFilters({ ...tableFilters, searchData: e });
    setCurrentpage(1);
  };

  const handleDeleteRow = () => {
    setSubmitLoading(true);
    SubAdminApi.deleteSubAdmin(deleteRowData[deleteRowData?.length - 1])
      .then((res) => {
        if (res?.status === 200) {
          getSubAdminList();
          notify.success(res?.message)
          setOpenDeleteConfirmModal(false);
          setSubmitLoading(false);
        }
      })
      .catch((error) => {
        notify.error(error)
        setSubmitLoading(false);
        setOpenDeleteConfirmModal(false);
      });
  };

  const handleRoleIdChange = (e) => {
    setRoleID(e.target.value);
    setCurrentpage(1);
  };

const handleModelData = (e, name, pi, setFieldValue) => {
  
  if (name == "userType") {
    setRoleDropDownId(e);
    const selectedRole = roleList.find((role) => String(role.id) === String(e));
    if (selectedRole) {
      const newSlug = selectedRole.slug || '';
      setroleDropDownSlug(newSlug);
      
      // Use Formik's setFieldValue to update the form values directly
      if (setFieldValue) {
        setFieldValue('slug', newSlug);
        setFieldValue('userType', e);
        setFieldValue('hospital', []);
        setFieldValue('principalInvestigator', newSlug === 'project-manager' ? [] : null);
        setFieldValue('trial', []);
      }
      
      // Also update initialValues for the component state
      setInitialValues(prev => ({
        ...prev,
        userType: e,
        slug: newSlug,
        hospital: [],
        principalInvestigator: newSlug === 'project-manager' ? [] : null,
        trial: []
      }));

      if (newSlug === 'project-manager') {
        setAllPIs([]);
      } else if (e == 5) {
        getPersonalInvestigatorList();
      }
    }
  }
  
  // FIX: Clear PIs when hospitals change for project managers
 // FIX: Clear only PIs related to removed hospitals, not all PIs
// OPTIMIZED FIX: Avoid duplicate API calls and handle empty hospital case
if (name === "hospital" && roleDropDownSlug === 'project-manager') {
  const selectedHospitals = Array.isArray(e) ? e : [e];
  const currentHospitals = Array.isArray(initialValues?.hospital) ? initialValues.hospital : [];
  
  // Find removed hospitals
  const removedHospitals = currentHospitals.filter(
    current => !selectedHospitals.some(selected => selected.id === current.id)
  );
  
  // Get current selected PIs
  const currentPIs = Array.isArray(initialValues?.principalInvestigator) 
    ? initialValues.principalInvestigator 
    : [];

  // Update hospital field immediately
  if (setFieldValue) {
    setFieldValue('hospital', e);
  }
  
  setInitialValues(prev => ({
    ...prev,
    hospital: e
  }));

  // Case 1: No hospitals selected - clear all PIs
  if (selectedHospitals.length === 0 || !selectedHospitals[0]?.id) {
    setAllPIs([]);
    if (setFieldValue) {
      setFieldValue('principalInvestigator', []);
    }
    setInitialValues(prev => ({
      ...prev,
      principalInvestigator: []
    }));
    return;
  }

  const hospitalIds = selectedHospitals.map(h => h.id);
  
  // Case 2: Hospitals were removed AND we have current PIs - filter existing PIs
  if (removedHospitals.length > 0 && currentPIs.length > 0) {
    // SINGLE API CALL: Fetch PIs for remaining hospitals
    EditorApi.getPIByHospitalIds({
      hospital_ids: hospitalIds
    })
      .then((res) => {
        const validPIOptions = res?.data?.map((pi) => ({
          id: pi.id,
          name: pi.name,
          label: pi.name
        }));
        
        // Filter current PIs to keep only those that are in valid PIs
        const filteredPIs = currentPIs.filter(currentPI => 
          validPIOptions.some(validPI => validPI.id === currentPI.id)
        );
        
        // Update form values with filtered PIs
        if (setFieldValue) {
          setFieldValue('principalInvestigator', filteredPIs);
        }
        
        setInitialValues(prev => ({
          ...prev,
          principalInvestigator: filteredPIs
        }));
        
        setAllPIs(validPIOptions);
      })
      .catch((error) => {
        notify.error(error);
        // On error, clear all PIs as fallback
        if (setFieldValue) {
          setFieldValue('principalInvestigator', []);
        }
        setInitialValues(prev => ({
          ...prev,
          principalInvestigator: []
        }));
        setAllPIs([]);
      });
  } 
  // Case 3: Hospitals added or changed, but no PIs to filter - just fetch available PIs
  else {
    // SINGLE API CALL: Fetch PIs for selected hospitals
    EditorApi.getPIByHospitalIds({
      hospital_ids: hospitalIds
    })
      .then((res) => {
        const piOptions = res?.data?.map((pi) => ({
          id: pi.id,
          name: pi.name,
          label: pi.name
        }));
        setAllPIs(piOptions);
        
        // If we have current PIs, validate them against new list
        if (currentPIs.length > 0) {
          const validPIs = currentPIs.filter(pi => 
            piOptions.some(validPI => validPI.id === pi.id)
          );
          
          if (validPIs.length !== currentPIs.length) {
            if (setFieldValue) {
              setFieldValue('principalInvestigator', validPIs);
            }
            setInitialValues(prev => ({
              ...prev,
              principalInvestigator: validPIs
            }));
          }
        }
      })
      .catch((error) => {
        notify.error(error);
        setAllPIs([]);
      });
  }
  return;
}
  
  if (pi == "principalInvestigator") {
    const piId = e?.id || e;
    
    if (piId) {
      getPhase(piId);
    } else {
      setPhaseList([]);
    }
  }
  
  if (name === "principalInvestigator" && !pi) {
    const piId = e?.id || e;
    if (piId) {
      getPhase(piId);
    } else {
      setPhaseList([]);
    }
  }
  
  // For other fields (non-hospital), update both form values and component state
  if (name !== "hospital" && (name === "principalInvestigator" || name === "trial")) {
    if (setFieldValue) {
      setFieldValue(name, e);
    }
    setInitialValues(prev => ({
      ...prev,
      [name]: e
    }));
  }
};

  const handleCellClick = (row, columnIndex) => {
    const rowIndex = getRowIndex(row);
    if (!userManagementResponse || !userManagementResponse[rowIndex]) {
      return;
    }

    const internalData = userManagementResponse[rowIndex]?.internalData;
    
    const piCountIndex = row.length - 3;
    const phaseCountIndex = row.length - 2;
    
    if (columnIndex === piCountIndex) {
      const piListData = internalData?.piListData || [];
      if (piListData.length > 0) {
        setPiListData(piListData);
        setOpenPiDrawer(true);
      } else {
        notify.info("No Principal Investigators assigned");
      }
    } 
    else if (columnIndex === phaseCountIndex) {
      const phaseListData = internalData?.phaseList || [];
      if (phaseListData.length > 0) {
        setPhaseListData(phaseListData);
        setOpenDrawer(true);
      } else {
        notify.info("No phases assigned");
      }
    }
  };

  const getRowIndex = (row) => {
    return userMangement?.rows?.indexOf(row) ?? -1;
  };

  // Filter PI list based on search
  const filteredPiListData = piListData.filter(pi => 
    pi.name.toLowerCase().includes(piSearch.toLowerCase())
  );

  return (
    <>
      <div className="flex flex-col gap-0 bg-white p-0 !pb-0">
        <CustomModel
          rowId={rowId}
          modalInitialValues={initialValues}
          initialValuesValidationSchema={addUserSchema}
          open={openEditModal ? openEditModal : openAddModal}
          setOpen={openEditModal ? setOpenEditModal : setOpenAddModal}
          setModelData={setModelData}
          modelData={modelData}
          isLoadingBtn={submitLoading}
          handleModelValues={
            openEditModal ? handleEditModelValues : handleAddModelValues
          }
         onChange={(e, name, pi, setFieldValue) => handleModelData(e, name, pi, setFieldValue)}
        />
        <CustomTable
          rows={userMangement?.rows}
          columnAlign={userMangement?.columnAlign}
          columns={userMangement?.columns}
          TableData={userMangement?.TableData}
          handleNavigate={handleNavigateToDetails}
          handleButtonClick={handleOpenAddModal}
          handleEditButton={(row) => {
            const rowIndex = getRowIndex(row);
            handleOpenEditPrincipalModal(row, rowIndex);
          }}
          handleDeleteButton={handleOpenDeleteConfirmModal}
          handleTableFilters={handleTableFilters}
          tableFilters={tableFilters}
          handleChangePage={handlePagination}
          handleChangeDropDown={handleRoleIdChange}
          dropDownValue={roleID}
          MenuList={roleList}
          loading={loading}
          currentPage={currentPage}
          totalpage={totalPage}
          handleCellClick={(row, columnIndex) => {
            handleCellClick(row, columnIndex);
          }}
        />
      </div>
      <DeleteConfirmContent
        open={openDeleteConfirmModal}
        setOpen={setOpenDeleteConfirmModal}
        handleDelete={handleDeleteRow}
        isLoading={submitLoading}
      />
      
      {/* Phase List Drawer */}
      {openDrawer && (
        <ListDrawer
          open={openDrawer}
          toggleDrawer={() => setOpenDrawer(!openDrawer)}
          listData={phaseListData || []}
          title="Phase List"
        />
      )}
      
      {/* PI List Drawer - Using the same UI as TrailManagement */}
      {openPiDrawer && (
        <CustomDrawer open={openPiDrawer} toggleDrawer={() => setOpenPiDrawer(!openPiDrawer)}>
          <div className="w-[25rem]">
            <div className="pl-4 pt-4 pr-4">
              <HeaderBackNav
                handleBackNav={() => setOpenPiDrawer(false)}
                TitleFontSize={"18px"}
                TitleFontWeight={700}
                Title="Principal Investigators"
              />
            </div>
            <hr />
            <div className="pl-3 pt-3 pr-3">
              <CustomSearchbar
                Placeholder="Search by Name"
                BgColor="#dfe0eb"
                value={piSearch}
                handleSearch={(value) => setPiSearch(value)}
              />
              <ul className="p-2 cursor-pointer">
                {loading ? (
                  <SkeletonLoader rowCount={5} height={"35px"} />
                ) : filteredPiListData?.length === 0 ? (
                  <div className="mt-4">
                    <NoDataCard />
                  </div>
                ) : (
                  filteredPiListData?.map((pi, index) => (
                    <li
                      key={pi?.id || index}
                      className="flex gap-3 align-center pt-2 pb-2"
                      style={{ borderBottom: "2px solid #dfe0eb" }}
                    >
                      <div className="self-center">
                        <DoctorIcon />
                      </div>
                      <div className="self-center">
                        <Typography variant="h6">
                          {pi?.name || "Name not available"}
                        </Typography>
                        {pi?.email && (
                          <Typography variant="body2" color="textSecondary">
                            {pi.email}
                          </Typography>
                        )}
                      </div>
                    </li>
                  ))
                )}
              </ul>
            </div>
          </div>
        </CustomDrawer>
      )}
    </>
  );
};